/* istanbul ignore file: please test in WEBSITE-7219 */
import { CompactUser } from 'src/context/user';
import {
  addToLocalStorageArrayEntry,
  hasInLocalStorageArrayEntry,
} from 'src/utils/webStorageArrayUtils';
import { HAS_SEEN_REMINDERS_SCREEN_STORAGE_KEY } from 'src/constants/storageKeys.const';

export const doesNotHaveSeenRemindersScreen = (user: CompactUser | null): boolean => {
  if (!user) return false;

  return !hasInLocalStorageArrayEntry(HAS_SEEN_REMINDERS_SCREEN_STORAGE_KEY, String(user.id));
};

export const addToRemindersScreenStorageEntry = (user: CompactUser | null): void => {
  if (!user) return;

  addToLocalStorageArrayEntry(HAS_SEEN_REMINDERS_SCREEN_STORAGE_KEY, String(user.id));
};
